<template>
  <div>
    <div
      class="spring-spinner"
      style="margin-top: 48px"
      v-if="!thereIsNoOrders && !errorMessage && !orders.length"
    >
      <div class="spring-spinner-part top">
        <div class="spring-spinner-rotator"></div>
      </div>
      <div class="spring-spinner-part bottom">
        <div class="spring-spinner-rotator"></div>
      </div>
    </div>
    <div
      class="tab-container"
      @scroll="scroll($event)"
      :style="`max-height: ${maxHeight}px !important;`"
      v-else-if="orders.length"
    >
      <OrderCard
        v-for="(order, index) in orders"
        :key="order.id"
        :data="order"
        @cancelled="removeOrder($event)"
        :besoin="besoin"
        :show_status="showStatusPerCard"
      />
      <div class="spring-spinner" v-if="loading">
        <div class="spring-spinner-part top">
          <div class="spring-spinner-rotator"></div>
        </div>
        <div class="spring-spinner-part bottom">
          <div class="spring-spinner-rotator"></div>
        </div>
      </div>
    </div>
    <div v-if="errorMessage">
      <p class="message">{{ errorMessage }}</p>
    </div>
    <div v-else-if="thereIsNoOrders">
      <p class="message">{{ $t("dispatching.infinityScroll.noOrders") }}</p>
    </div>
  </div>
</template>

<script>
import OrderCard from "@/components/dispatching/OrderCard";
import axios from "axios";

export default {
  name: "InfinityScroll",
  components: {
    OrderCard,
  },
  props: {status: {
    required: false
  }, multiStatus: {
    required: false
  }, time: {
    required: false
  }, besoin: {
    required: false
  }, passengerId: {
    required: false,
    default: null
  }, maxHeight: {
    required: false,
    default: '553'
  },showStatusPerCard: {
    type: Boolean,
    required:false,
    default: false
  }},
  computed: {
    statuses: function () {
      if (!this.status && this.multiStatus) return this.multiStatus.split("|");
      else return false;
    },
    thereIsNoOrders() {
      if (this.loading) return false;
      else if (this.orders.length > 0) return false;
      else return true;
    },
  },
  data() {
    return {
      orders: [],
      errorMessage: "",
      page: 1,
      lastPage: 0,
      loading: true,
    };
  },
  created() {
    if(!this.passengerId) {
      if (!this.multiStatus) this.initData(this.status);
      else {
        this.statuses.forEach((el) => {
          this.initData(el);
        });
      }
    }
  },
  watch: {
    time: function () {
      this.orders = [];
      this.loading = true;
      if (!this.multiStatus) this.initData(this.status);
      else {
        this.statuses.forEach((el) => {
          this.initData(el);
        });
      }
    },
    besoin: function () {
      this.orders.forEach((el, index) => {
        if (el.id === this.besoin) {
          el.besoin = this.besoin;
          console.log("BESOIN RENEW");
          console.log(this.besoin);
        } else {
          el.besoin = false;
        }
      });
    },
    passengerId: {
      handler: function (newId) {
        this.getOrdersByPassengerId(newId);
      },
      immediate:true
    }
  },
  methods: {
    removeOrder(id) {
      let order;
      console.log("Order to cancel: ", id);
      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].id && this.orders[i].id == id) {
            order = this.orders[i];
            this.orders.splice(i, 1);
            if (order.now == '0')
              this.$emit('decreaseCount');
            return order || null;
          }
      }
    },
    addOrder(data) {
      this.orders.unshift(data);
    },
    initData(status) {
      this.$store
        .dispatch("getOrders", {
          status: status,
          time: this.time,
          filter: "BOTH",
        })
        .then((response) => {
          if (response.data.length) {
            this.lastPage = response.last_page;
            response.data.forEach((el) => {
              this.orders.push(el);
              this.$emit("loaded", el);
              this.$emit("updateTotal", response.total);
            });
          }
        })
        .catch((error) => {
          this.errorMessage = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeFromList(index) {
      this.orders.splice(index, 1);
    },
    getOrdersByPassengerId(id) {
      if(!id) return;
      this.loading = true;
      axios.get('booking', {
        params: {
          passenger_id: id,
          perPage: 100,
          status: 'ALL',
          from: moment().subtract(3, 'hours').format('YYYY-MM-DD HH:mm:ss')
          //to: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      })
      .then((res) => {
        this.orders = res.data.data.data;
      })
      .catch((err) => {
        this.errorMessage = err.response.data.message;
      })
      .finally(() => {
        this.loading = false;
      })
    },
    loadData(page, status) {
      if (this.page < this.lastPage) {
        this.$store
          .dispatch("getOrdersPageData", {
            page: page,
            status: status,
            time: this.time,
            filter: "BOTH",
          })
          .then((response) => {
            console.log(response);
            this.page++;
            response.data.forEach((el) => {
              this.orders.push(el);
              this.$emit("loaded", el);
            });
          })
          .catch((error) => {
            this.errorMessage = error;
            // console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    scroll(event) {
      if(!this.passengerId) {
        console.log("-------EVENT------");
        console.log(Math.round(event.target.scrollTop), event.target.offsetHeight, event.target.scrollHeight);
        console.log("-------------");
        console.log("first one ", event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight);
        console.log("second one ", this.page < this.lastPage);
        console.log("third one ", !this.loading);
        console.log("-------END-----");
        let diff = +(Math.abs((Math.round(event.target.scrollTop) + event.target.offsetHeight) - event.target.scrollHeight) <= 1);
        if (
          Math.round(event.target.scrollTop) + diff + event.target.offsetHeight >=
          event.target.scrollHeight &&
          this.page < this.lastPage &&
          !this.loading
          ) {
          console.log("Reached the bottom");
          this.loading = true;
          if (!this.multiStatus) this.loadData(this.page + 1, this.status);
          else {
            this.statuses.forEach((el) => {
              this.loadData(this.page + 1, el);
            });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-container {
  width: 100%;
  height: 100%;
  float: left;
  overflow-y: overlay;
  max-height: 553px;
  padding: 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tab-container::-webkit-scrollbar {
  width: 0.2em;
}

.tab-container::-webkit-scrollbar-track {
  background-color: transparent;
}

.tab-container::-webkit-scrollbar-thumb {
  background-color: #c1c5d8;
  border-radius: 9999px;
}

/* Spinner */

.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.spring-spinner {
  height: 100%;
  max-height: 24px;
  width: auto;
  max-width: 24px;
  margin: auto;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  max-height: 12px;
  height: 100%;
  width: auto;
  max-width: 24px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 24px;
  height: 24px;
  border: 2.5px solid transparent;
  border-right-color: white;
  border-top-color: #d9d9d9;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

@keyframes spring-spinner-animation {
  50% {
    transform: rotate(115deg);
  }
}

// w-full text-center mb-16 text-gray
.message {
  width: 100%;
  text-align: center;
  float: left;
  color: #788e98;
  margin-top: 12px;
}
</style>
